import React from "react";
import { Link } from 'react-router-dom';
import "./personlizeloan.scss";
import formUrlEncoded from "form-urlencoded";
import { connect } from "react-redux";
import { savePersonalizedQuote } from "../../actions/crossSellApplicationActions";
import { Redirect } from 'react-router';
import { getOfferPreFilledData } from "../../selectors";

const genSlideStyle = (value, min, max, step, maxAllowed) => {
  if(max===min){
    return {
      point: {
        left: `calc(100% - ${5 + 3 }px)`
      },
      range: {
        width: `calc(100%)`
      }
    };
  }else if(value==maxAllowed){
    return {
      point: {
        left: `calc(${100}% - ${5 + 3 }px)`
      },
      range: {
        width: `calc(${100}%)`
      }
    };
  }else{
    return {
      point: {
        left: `calc(${100 * ( value - min ) / ( max - min )}% - ${5 + 3 }px)`
      },
      range: {
        width: `calc(${100 * ( value - min ) / ( max - min )}%)`
      }
    };
  }
};

export class PersonlizeLoan extends React.Component {

  constructor(props) {
    super(props);
    const userSelectedLoanAmount= props.crossSellPersonalizedQuote.loanAmount;
    const personalizedLoanAmount = userSelectedLoanAmount ? userSelectedLoanAmount : props.maxAmount;
    const paymentDueDate = props.crossSellPersonalizedQuote.paymentDueDate ? props.crossSellPersonalizedQuote.paymentDueDate : null;
    this.state = {
      loanAmount: personalizedLoanAmount,
      min: props.minAmount,
      max: props.maxAmount,
      maxSlider: parseInt(props.maxAmount)%500!=0?parseInt(props.maxAmount) + (500-(parseInt(props.maxAmount) % 500)): props.maxAmount,
      step: 500,
      aprs: props.aprs,
      isOfferSelected: props.crossSellPersonalizedQuote.loanAmount ? true : false,
      crossSellPersonalizedQuote: {
        monthlyPayment: props.crossSellPersonalizedQuote.monthlyPayment ? props.crossSellPersonalizedQuote.monthlyPayment : null,
        termInMonths: props.crossSellPersonalizedQuote.termInMonths ? props.crossSellPersonalizedQuote.termInMonths : null,
        apr: props.crossSellPersonalizedQuote.apr ? props.crossSellPersonalizedQuote.apr : null,
        loanAmount: props.crossSellPersonalizedQuote.loanAmount ? props.crossSellPersonalizedQuote.loanAmount : null,
        costOfLoan: props.crossSellPersonalizedQuote.costOfLoan ? props.crossSellPersonalizedQuote.costOfLoan : null,
        paymentDueDate: paymentDueDate
      },
      submitSucceeded: false,
      paymentDueDate: paymentDueDate,
      selectedOfferIndex: 0,
      resetSelected: false,
      showTapToEditValErr: false,
      tapToEdit: userSelectedLoanAmount ? userSelectedLoanAmount : "",
      tapToEditText: `tap to edit value between ${ props.minAmount }to ${ props.maxAmount}`,
      totalReward: {},
      currency: props.rewardDisplayCurrency,
      currencyPrefix: props.currencyPrefix,
      calculationCaller: null,
      isLoadingOffer: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleOfferChange = this.handleOfferChange.bind(this);
    this.handlePersonalizedQuoteRequest = this.handlePersonalizedQuoteRequest.bind(this);
    this.updateOffers = this.updateOffers.bind(this);
    this.tapToEditVal = this.tapToEditVal.bind(this);
  }

  tapToEditVal(e) {
    let value;
    e.target.placeholder = '';
    let inputValIs = e.target.value;
    inputValIs = inputValIs.replace(/,/g, '');
    value = inputValIs;
    this.setState({ tapToEdit: inputValIs });
    if(inputValIs >= parseInt(e.target.min)&& inputValIs <=parseInt(e.target.max)) {
      this.handleChange(e);
      this.setState({ showTapToEditValErr: false });
    } else if(inputValIs > parseInt(e.target.max)){
      value=value.substr(0, value.length-1);
      this.updatedValue(value);
      if(value < parseInt(e.target.min)){
        this.setState({ showTapToEditValErr: true });
      }
      if(!(parseInt(value) < parseInt(e.target.min) || parseInt(inputValIs) > parseInt(e.target.max))){
        const updatedValue = value.replace(/,/g, '');
        this.updateOffers(updatedValue);
      }
    }else{
      this.setState({ showTapToEditValErr: true, loanAmount: e.target.min });
    }
  }
  updatedValue = (updateValue) => {
    this.setState({
      resetSelected: true,
      isOfferSelected: false,
      showTapToEditValErr: false,
      tapToEdit: new Intl.NumberFormat().format(updateValue)
    });
  };

  handleChange = (e) => {
    const updatedValue = (e.target.value).replace(/,/g, '');
    clearTimeout(this.state.calculationCaller);
    const self = this;
    let selectedValue = updatedValue;
    if(parseInt(updatedValue) > parseInt(this.state.max)){
      selectedValue=this.state.max;
    }
    this.setState({ loanAmount: selectedValue, resetSelected: true, isOfferSelected: false, showTapToEditValErr: false });
    this.state.calculationCaller = setTimeout(() => { self.updateOffers(selectedValue); }, 200);
    this.setState({ tapToEdit: new Intl.NumberFormat().format(selectedValue) });
  };

  updateOffers(loanAmount){
    this.calculateMonthlyPayment(loanAmount);
  }

  calculateMonthlyPayment=async(loanAmount)=> {
    const actionName = 'calculateMonthlyPayment';
    const body = `${formUrlEncoded({ userRequestedLoanAmount: loanAmount }) }&${actionName}=`;
    this.setState({ isLoadingOffer: true });
    await fetch('/clapply/action/customizeOffer', {
      credentials: 'include',
      method: 'POST',
      body: body,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => {
      this.setState({ isLoadingOffer: false });
      return response.json();
    }, rejected => {
      this.setState({ isLoadingOffer: false });
    }).then(data => {
      this.setState({ aprs: data.aprs });
      this.setState({ paymentDueDate: data.paymentDueDate });
      this.setState({ totalReward: data.totalReward });
      if(this.state.selectedOfferIndex && this.state.aprs[this.state.selectedOfferIndex]) {
        this.setState({
          crossSellPersonalizedQuote: {
            monthlyPayment: this.state.aprs[this.state.selectedOfferIndex].monthlyPayment,
            termInMonths: this.state.aprs[this.state.selectedOfferIndex].term,
            apr: this.state.aprs[this.state.selectedOfferIndex].apr,
            loanAmount: this.state.loanAmount,
            costOfLoan: this.state.aprs[this.state.selectedOfferIndex].costOfLoan
          }
        });
      }
    });
  }
  componentWillMount() {
    this.setState({
      tapToEdit: new Intl.NumberFormat().format(this.state.loanAmount)
    });
  }
  componentDidMount() {
    this.updateOffers(this.state.loanAmount);
    this.state.aprs.map((e, index) => {
      const selected = this.state.crossSellPersonalizedQuote.termInMonths === e.term ? true : false;
      if(selected) this.setState({ selectedOfferIndex: index });
    });
  }

  handleOfferChange = (e) => {
    this.setState({
      crossSellPersonalizedQuote: {
        monthlyPayment: this.state.aprs[e.target.id].monthlyPayment,
        termInMonths: this.state.aprs[e.target.id].term,
        apr: this.state.aprs[e.target.id].apr,
        loanAmount: this.state.loanAmount,
        costOfLoan: this.state.aprs[e.target.id].costOfLoan
      },
      selectedOfferIndex: e.target.id,
      resetSelected: false
    });
    this.setState({ isOfferSelected: true });
  };

  handlePersonalizedQuoteRequest = () => {
    this.props.savePersonalizedQuote({
      "monthlyPayment": this.state.aprs[this.state.selectedOfferIndex].monthlyPayment,
      "termInMonths": this.state.aprs[this.state.selectedOfferIndex].term,
      "apr": this.state.aprs[this.state.selectedOfferIndex].apr,
      "loanAmount": this.state.loanAmount,
      "costOfLoan": this.state.aprs[this.state.selectedOfferIndex].costOfLoan,
      "paymentDueDate": this.state.paymentDueDate,
      "totalReward": this.state.totalReward
    }, { mover: this.props.mover, nextPage: "/clapply/action/customizeOffer/addBankDetails" });
    this.setState({ submitSucceeded: false });
  };

  onKeyPress = (event) =>{
    if (!/[0-9]/.test(event.key)) {
      if(event.key === 'Enter'){
        event.currentTarget.blur();
      } else {
        event.preventDefault();
      }
    }
  }

  onKeyUp = (event) =>{
    let tabToEditValue = this.state.tapToEdit;
    if(tabToEditValue){
      tabToEditValue = tabToEditValue.replaceAll(',', '' );
    }
    const isNotEmpty = tabToEditValue !== null && tabToEditValue !== undefined && tabToEditValue.trim().length>0;
    if((tabToEditValue === "NaN" || tabToEditValue === NaN || isNaN(tabToEditValue)) && isNotEmpty){
      this.setState({
        tapToEdit: ''
      });
    }else{
      this.tapToEditVal(event);
    }
  }

  render() {
    if (this.state.submitSucceeded) {
      return <Redirect push to="/clapply/action/customizeOffer/addBankDetails" />;
    }
    const { showTapToEditValErr } = this.state;
    const slideStyle = genSlideStyle(this.state.loanAmount, this.state.min, this.state.maxSlider, this.state.step, this.state.max);
    const { crossSellPersonalizedQuote } = this.state;
    const isEnabled = (this.state.showTapToEditValErr === false);
    const enableContinueBtn = (this.state.isLoadingOffer === true || this.state.isOfferSelected === false || this.state.showTapToEditValErr === true);
    let errorType = '';
    if(showTapToEditValErr){
      errorType = (<span>Please enter value between ${new Intl.NumberFormat().format(this.state.min)} & ${new Intl.NumberFormat().format(this.state.max)}</span>);
    }
    const rewardEnabled = this.props.rewardEnabled;
    let displayRewardValue = null;
    if(rewardEnabled){
      displayRewardValue=( this.state.totalReward.value? new Intl.NumberFormat().format(this.state.totalReward.value):null);
    }
    return (
      <div className="row">
        <div className="col col-sm-8 col-md-8 col-lg-7 mx-auto">
          <div className="cl-perl">
            <div className="cl-card padding-bottom-0">
              <p className="cl-p">Select your desired loan amount</p>
              <div className="cl-cardbody">
                {this.state.max === this.state.min ?null:<p>Tap to edit</p>}

                <h3><span className="append-dollar">$</span>
                  {this.state.max === this.state.min ?
                    <input
                      type="text"
                      placeholder={this.state.loanAmount ? new Intl.NumberFormat().format(this.state.loanAmount) : new Intl.NumberFormat().format(this.state.max)}
                      className="tapToEdit"
                      min={this.state.min}
                      max={this.state.max}
                      minLength="4"
                      maxLength="6"
                      onChange={this.tapToEditVal}
                      value={this.state.tapToEdit}
                      pattern="^[0-9]+$"
                      onKeyPress={(event)=>this.onKeyPress(event)}
                      onKeyUp={(event)=>this.onKeyUp(event)}
                      id="tapToEditRangeValue"
                      readOnly
                    />:
                    <input
                      type="text"
                      placeholder={this.state.loanAmount ? new Intl.NumberFormat().format(this.state.loanAmount) : new Intl.NumberFormat().format(this.state.max)}
                      className="tapToEdit"
                      min={this.state.min}
                      max={this.state.max}
                      minLength="4"
                      maxLength="6"
                      onChange={this.tapToEditVal}
                      value={this.state.tapToEdit}
                      pattern="^[0-9]+$"
                      onKeyPress={(event)=>this.onKeyPress(event)}
                      onKeyUp={(event)=>this.onKeyUp(event)}
                      id="tapToEditRangeValue"
                    />}
                </h3>
                <div className="range">
                  <input
                    className="range-slide"
                    name="range"
                    type="range"
                    min={this.state.min}
                    max={this.state.maxSlider}
                    value={parseInt(this.state.loanAmount) == parseInt(this.state.max) ? parseInt(this.state.maxSlider) : this.state.loanAmount }
                    step={this.state.step}
                    onChange={this.handleChange}
                    aria-labelledby="tapToEditRangeValue"
                  />
                  <span className="range-value" style={slideStyle.range} />
                  <span className="circle" style={slideStyle.point} />
                </div>
                <div className="row">
                  <div className="col-6 text-left">
                    <span>${new Intl.NumberFormat().format(this.state.min)}</span>
                  </div>
                  <div className="col-6 text-right">
                    <span>${new Intl.NumberFormat().format(this.state.max)}</span>
                  </div>
                </div>
                {
                  (rewardEnabled && displayRewardValue)
                    ?
                    <div>
                      <div className="rewardbox"></div>
                      <div className="rewards-cont ">

                        <div className="rewards-image"></div>

                        <div className="text-left rewards-text">
                          <div>Total rewards</div>
                        </div>
                        <div className=" text-right rewards-value">
                          {this.state.isLoadingOffer ?
                            <div className="custom-loader">
                              <div></div>
                            </div>
                            :
                            <span>
                              <span
                                className="rewards-value-span">{this.state.currencyPrefix}{displayRewardValue}</span> <span className="rewards-value-span">{this.state.currency}</span>
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    : null
                }
              </div>
              <p className="err-block" role="alert">
                {errorType}
              </p>
              <p className="cl-p pt-15">Select your offer</p>
              <ul className="list-group cl-list">
                {
                  this.state.aprs.map((e, index) => {
                    let checked =((crossSellPersonalizedQuote.termInMonths === e.term ? true : false) && showTapToEditValErr === false);
                    if(this.state.resetSelected){
                      checked = false;
                    }
                    return(
                      <li key={`list-${index}`} className="list-group-item cl-list-item d-flex justify-content-between align-items-center">
                        <div>
                          <label htmlFor={index}>
                            <div className="cl-h5title">${e.monthlyPayment}/month</div>
                            <span>for {e.term} months at {e.apr}% APR</span>
                          </label>
                        </div>
                        <span className="badge">
                          <div className="cl-rdio cl-rdio-primary radio-inline">
                            <input
                              name="radio" value="1" id={index}
                              checked={checked}
                              type="radio"
                              onChange={this.handleOfferChange}
                            />
                            <label htmlFor={index}
                              className={ isEnabled ? '' : 'disable-this'} />
                          </div>
                        </span>
                      </li>
                    );
                  }
                  )
                }
              </ul>

              <div className="col-12 text-center">
                <button type="submit" aria-label="click to continue to the next page" data-track="custom-links" className="btn-per margin-btn" tabIndex="0" onClick={this.handlePersonalizedQuoteRequest} disabled={enableContinueBtn}>
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { savePersonalizedQuote };
export default connect(null, mapDispatchToProps)(PersonlizeLoan);
